<template>
<div>
	<div class="news">
		<div class="newsList">
					<div class="newsItems" v-for="item in list" @click="toDetail(item.id)">
						<div class="newsItemLeft">
							<div class="newsDate">{{item.month_text}}</div>
							<div class="newsYear">{{item.year_text}}</div>
						</div>
						<div class="newsCenter">
							<div class="newsTitle">{{item.title}}</div>
							<div class="newsDesc" v-html="getFirstLine(item.content)"><span>...</span></div>
						</div>
						<div>
							<img :src="item.image"  class="newsImg"/>
						</div>
					</div>
				</div>
				<el-pagination     
				 @size-change="handleSizeChange"
				  @current-change="handleCurrentChange"
				  :current-page="currentPage"
				  :page-size="pageSize"
				  layout="total, prev, pager, next, jumper"
				  :total="total"
				  :hide-on-single-page="true"
				  style="margin-top: 20px; text-align: right;"
		></el-pagination>
	</div>
</div>
</template>

<script>
//const baseURL = 'https://api.test.laborhub.cn/'; // 测试环境
const baseURL = 'https://api.laborhub.cn/'; // 正式环境
import axios from 'axios';
export default {
		name: 'news',
		props: {
			showPop:false
		},
	data() {
		return {
			list:[],
			currentPage: 1, // 当前页码
			pageSize: 5,   // 每页条数
			total: 0        ,// 数据总条数
		};
	},
	onLoad(){

	},
	created() {
		this.httpRequest();
	},
	methods: {
		toDetail(id){
			this.$emit('active','detail');
			this.$emit('change-id',id);
			this.showMobileMenu = false; // 关闭移动端菜单
		},
		// 切换每页条数时触发
		handleSizeChange(val) {
			this.pageSize = val
			this.currentPage = 1 // 改变条数时，通常重置回第一页
			this.httpRequest()     // 重新请求数据
		},
		// 切换页码时触发
		handleCurrentChange(val) {
			this.currentPage = val
			this.httpRequest()     // 重新请求数据
		},
		getFirstLine(html) {
			// 查全部内容显示第一行文字信息
			const tempDiv = document.createElement('p');
			tempDiv.innerHTML = html;
			// 获取第一行文字（通常是第一个 <br> 之前的所有内容）
			let firstLine = tempDiv.innerText.split('\n')[0]; // 或者使用 split('\n')[0]、 split('<br>')[0] 根据实际情况选择分割方式
			return firstLine;
		},
		async httpRequest() {
			try {
			// 发起 GET 请求
				const response = await axios.get(baseURL+'openapi/news/list',{
					          params: {
					            page: this.currentPage,
					            pageSize: this.pageSize
					          }
				});
				window.scrollTo(0,0);
				this.list = response.data.data.data;
				this.total = response.data.data.total
			} catch (error) {
				console.error('请求失败:', error)
			} 
		},
	}
}
</script>

<style scoped>
@import './index.css';
</style>
